/* Category sibling navigation only. Never writes picker, form, history, storage or purchase state. */
(function (win, factory) {
  'use strict';
  var api = factory();
  if (win) win.ShamosSiblingMatcher = api;
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!win || !win.customElements || win.customElements.get('shamos-clear-sibling')) return;
  class ClearSibling extends win.HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.hidden = true;
      this.clearLinks();
      if (this.initialize()) return;
      // Custom elements can connect before their parser-created JSON child exists.
      var attempts = 0;
      if (win.MutationObserver) {
        this.dataObserver = new win.MutationObserver(() => {
          if (!this.connected || this.initialize() || ++attempts >= 64) this.stopWaiting();
        });
        this.dataObserver.observe(this, { childList: true, subtree: true, characterData: true });
        this.dataTimer = win.setTimeout(() => this.stopWaiting(), 5000);
      }
    }
    stopWaiting() {
      if (this.dataObserver) this.dataObserver.disconnect();
      if (this.dataTimer) win.clearTimeout(this.dataTimer);
      this.dataObserver = null;
      this.dataTimer = null;
    }
    readConfig(row) {
      try {
        var script = row.querySelector('[data-clear-sibling-data]');
        return script && api.config(JSON.parse(script.textContent));
      } catch (_) { return null; }
    }
    initialize() {
      if (this.config) return true;
      var config = this.readConfig(this);
      if (!config || !this.querySelector('ul')) return false;
      this.config = config;
      this.stopWaiting();
      this.scope = this.closest('[data-model-choice-state]');
      this.onChange = () => this.update();
      this.onNative = (event) => this.nativeUpdate(event);
      this.onPending = (event) => {
        if (this.config.source.category !== 'phone' && event.target === this.nativePicker()) this.update();
      };
      this.onClick = (event) => {
        var link = event.target && event.target.closest && event.target.closest('[data-clear-sibling-link]');
        if (!link || !this.contains(link)) return;
        this.update();
        var item = link.closest('li');
        if (this.hidden || !this.contains(link) || !item || item.hidden || !link.getAttribute('href')) event.preventDefault();
      };
      if (this.scope) this.scope.addEventListener('shamos:model-choice-change', this.onChange);
      this.nativeEvent = 'maximize:variant-picker:updated:' + this.config.sectionId;
      this.ownerDocument.addEventListener(this.nativeEvent, this.onNative);
      this.pendingEvent = 'shamos:variant-render-pending:' + this.config.sectionId;
      this.ownerDocument.addEventListener(this.pendingEvent, this.onPending);
      this.addEventListener('click', this.onClick, true);
      this.addEventListener('auxclick', this.onClick, true);
      this.update();
      return true;
    }
    disconnectedCallback() {
      this.connected = false;
      this.stopWaiting();
      if (this.scope) this.scope.removeEventListener('shamos:model-choice-change', this.onChange);
      if (this.nativeEvent) this.ownerDocument.removeEventListener(this.nativeEvent, this.onNative);
      if (this.pendingEvent) this.ownerDocument.removeEventListener(this.pendingEvent, this.onPending);
      this.removeEventListener('click', this.onClick, true);
      this.removeEventListener('auxclick', this.onClick, true);
      this.cancelImages();
      this.clearLinks();
      this.hidden = true;
      this.config = null;
      this.scope = null;
      this.nativeEvent = null;
      this.pendingEvent = null;
      this.nativeSeen = false;
      this.nativeVariant = null;
    }
    clearLinks() {
      this.querySelectorAll('[data-clear-sibling-link]').forEach((link) => {
        link.removeAttribute('href');
        link.removeAttribute('aria-label');
      });
    }
    parts(item) {
      var card = item.querySelector('.clear-sibling__card') || item.querySelector('a') || item;
      var media = item.querySelector('.clear-sibling__media');
      var img = item.querySelector('img');
      if (!media) {
        media = this.ownerDocument.createElement('span');
        media.className = 'clear-sibling__media';
        card.insertBefore(media, card.firstChild);
      }
      if (!img) img = this.ownerDocument.createElement('img');
      if (img.parentNode !== media) media.insertBefore(img, media.firstChild);
      var fallback = item.querySelector('[data-clear-sibling-fallback]');
      if (!fallback) {
        fallback = this.ownerDocument.createElement('span');
        fallback.setAttribute('data-clear-sibling-fallback', '');
        media.appendChild(fallback);
      }
      var status = item.querySelector('[data-clear-sibling-status]');
      if (!status) {
        status = this.ownerDocument.createElement('span');
        status.setAttribute('data-clear-sibling-status', '');
        card.appendChild(status);
      }
      return { img: img, fallback: fallback, status: status };
    }
    cancelImage(item) {
      item.imageToken = (item.imageToken || 0) + 1;
      item.imageKey = null;
      item.imageStatus = null;
      var img = item.querySelector('img');
      if (img) {
        img.hidden = true;
        img.style.visibility = 'hidden';
        img.removeAttribute('src');
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
      }
    }
    cancelImages() { this.querySelectorAll('li').forEach((item) => this.cancelImage(item)); }
    image(item, media, alt, fallbackText) {
      var parts = this.parts(item), old = parts.img;
      item.imageAlt = alt;
      old.alt = alt;
      old.removeAttribute('srcset');
      old.removeAttribute('sizes');
      if (!media) {
        this.cancelImage(item);
        parts.fallback.hidden = false;
        parts.fallback.textContent = fallbackText || 'Photo unavailable';
        return 'missing';
      }
      var key = media.id + ':' + media.src;
      if (item.imageKey !== key) {
        this.cancelImage(item);
        item.imageKey = key;
        item.imageStatus = 'pending';
        var token = item.imageToken;
        var next = new win.Image(72, 72);
        next.alt = alt;
        next.decoding = 'async';
        next.onload = () => {
          if (!this.connected || !this.contains(item) || token !== item.imageToken || item.imageKey !== key) return;
          item.imageStatus = 'ready';
          next.alt = item.imageAlt;
          old.replaceWith(next); // Fresh image cannot retain another model's responsive srcset.
          this.update();
        };
        next.onerror = () => {
          if (!this.connected || !this.contains(item) || token !== item.imageToken || item.imageKey !== key) return;
          item.imageStatus = 'error';
          this.update();
        };
        next.src = api.thumbnail(media.src, win.location.href);
      }
      var ready = item.imageStatus === 'ready';
      old.hidden = !ready;
      old.style.visibility = ready ? '' : 'hidden';
      parts.fallback.hidden = ready;
      parts.fallback.textContent = fallbackText || 'Photo unavailable';
      return item.imageStatus;
    }
    nativePicker() {
      if (!this.config) return null;
      var pickers = Array.from(this.ownerDocument.querySelectorAll('variant-picker')).filter((picker) =>
        String(picker.dataset.productId) === this.config.source.id && String(picker.dataset.sectionId) === this.config.sectionId);
      return pickers.length === 1 ? pickers[0] : null;
    }
    nativeUpdate(event) {
      var detail = event && event.detail;
      if (!this.config || !detail || String(detail.productId) !== this.config.source.id || String(detail.sectionId) !== this.config.sectionId) return;
      if (this.config.source.category !== 'phone') {
        var picker = this.nativePicker();
        if (!picker || !Number.isInteger(detail.renderVersion) || detail.renderVersion < 1 || detail.renderVersion !== picker.renderVersion || detail.renderVersion !== picker.siblingSettledRenderVersion) return;
      }
      // Native rendering already fetched the section. Reuse only this row, never another form or picker.
      var html = detail.updatedHTML;
      if (html && typeof html.querySelectorAll === 'function' && this.id) {
        var rows = Array.from(html.querySelectorAll('shamos-clear-sibling')).filter((row) => row.id === this.id);
        if (html.id === this.id && html.tagName && html.tagName.toLowerCase() === 'shamos-clear-sibling') rows.unshift(html);
        if (rows.length === 1) {
          var row = rows[0], config = this.readConfig(row), list = row.querySelector('ul');
          if (config && list && config.sectionId === this.config.sectionId && config.source.id === this.config.source.id && config.source.category === this.config.source.category) {
            this.cancelImages();
            this.clearLinks();
            this.querySelector('ul').innerHTML = list.innerHTML;
            this.querySelector('[data-clear-sibling-data]').textContent = row.querySelector('[data-clear-sibling-data]').textContent;
            ['[data-clear-sibling-note]', '[data-clear-sibling-browse]'].forEach((selector) => {
              var incoming = row.querySelector(selector), existing = this.querySelector(selector);
              if (incoming && existing) existing.innerHTML = incoming.innerHTML;
            });
            this.config = config;
          }
        }
      }
      this.nativeSeen = true;
      this.nativeVariant = api.selected(this.config.source, detail.currentVariant);
      this.update();
    }
    update() {
      if (!this.connected || !this.config) return;
      var source = this.config.source;
      var state;
      if (source.category === 'phone') {
        state = win.ShamosModelChoice && typeof win.ShamosModelChoice.getState === 'function' ? win.ShamosModelChoice.getState(this) : null;
        if (state && (String(state.productId) !== source.id || state.state === 'pending')) {
          this.hidden = true;
          this.clearLinks();
          this.cancelImages();
          return;
        }
      } else {
        var picker = this.nativePicker();
        // Read the owning native request on every activation, including late connection and retry.
        if ((!picker && source.variantCount > 1) || (picker && picker.renderVersion && picker.renderVersion !== picker.siblingSettledRenderVersion)) {
          this.hidden = true;
          this.clearLinks();
          this.cancelImages();
          return;
        }
        var selected = picker && 'currentVariant' in picker ? api.selected(source, picker.currentVariant) : (this.nativeSeen ? this.nativeVariant : api.initial(source));
        state = { productId: source.id, ready: Boolean(selected), state: selected ? 'ready' : 'unset', variantId: selected && selected.id };
      }
      var original = api.sourceVariant(source, state);
      var current = this.querySelector('[data-clear-sibling-current]');
      if (current) {
        current.hidden = false;
        var currentLabel = original ? original.options.join(' · ') : source.category === 'phone' ? (source.modelPosition ? 'Choose your phone model' : 'Current product') : 'Choose options';
        var currentMedia = original ? api.media(source, original) : api.browsingMedia(source, source, state, win.location.href);
        var currentStatus = this.image(current, currentMedia, 'Current design: ' + source.title + ': ' + currentLabel, source.title || 'Current design');
        this.parts(current).status.textContent = currentLabel;
        var currentCard = current.querySelector('.clear-sibling__card');
        if (currentCard) currentCard.setAttribute('aria-label', 'Current design: ' + source.title + ': ' + currentLabel + (currentStatus === 'ready' ? '' : '; no photo'));
      }
      // Clear all entries first, including stale markup not represented by the latest config.
      this.querySelectorAll('[data-clear-sibling-item]').forEach((item) => { item.hidden = true; });
      this.clearLinks();
      var visible = 0, choosing = 0;
      this.config.targets.forEach((target) => {
        var item = this.querySelector('[data-clear-sibling-item="' + target.id + '"]');
        var link = item && item.querySelector('[data-clear-sibling-link]');
        if (!link) return;
        var decision = api.resolve(source, target, state);
        var href = decision.kind !== 'omit' && visible < this.config.maxVisible && api.url(target.url, decision.variant && decision.variant.id, win.location.href, source.category === 'phone');
        if (!href) { this.cancelImage(item); return; }
        var exact = decision.kind === 'exact';
        var label = exact ? decision.variant.options.join(' · ') : source.category === 'phone' && original ? original.options[source.modelPosition - 1] + ' preview; choose options on this design' : source.category === 'phone' ? 'Choose your phone model' : 'Choose options';
        var image = exact ? api.media(target, decision.variant) : api.previewMedia(source, target, state) || api.browsingMedia(source, target, state, win.location.href);
        var status = this.image(item, image, '', 'Photo unavailable');
        this.parts(item).status.textContent = exact && original ? decision.variant.options.filter(function (option) { return !original.options.includes(option); }).join(' · ') : (original && source.category !== 'phone' ? label : '');
        link.setAttribute('href', href);
        link.setAttribute('aria-label', target.title + ': ' + label + (status === 'ready' ? '' : '; ' + (status === 'pending' ? 'photo loading' : 'no photo')));
        item.hidden = false;
        visible++;
        if (!exact) choosing++;
      });
      var note = this.querySelector('[data-clear-sibling-note]');
      if (note) note.textContent = source.category === 'phone' ? (original ? 'Selected: ' + original.options.join(' · ') + '.' + (choosing ? ' Some designs require a new option choice.' : '') : 'Choose your phone model on the next design.') + ' Case types and features may differ.' : (original ? 'Selected: ' + original.options.join(' · ') + '. Related designs in this category.' + (choosing ? ' Choose options on the next design where shown.' : '') : 'Choose options on the next design.');
      this.hidden = visible === 0;
    }
  }
  win.customElements.define('shamos-clear-sibling', ClearSibling);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var CATEGORIES = ['phone', 'stand', 'airpods', 'airpods-max', 'kindle', 'wallet'];
  function id(value) { return value == null ? '' : String(value); }
  function positive(value) { return /^[1-9][0-9]*$/.test(id(value)) && (typeof value !== 'number' || Number.isSafeInteger(value)); }
  function name(value) { return value.trim().toLowerCase(); }
  function sourceURL(value) {
    if (typeof value !== 'string' || !value.trim() || /[\u0000-\u0020\\]/.test(value)) return null;
    try {
      var parsed = new URL(value, 'https://sibling.invalid');
      return /^(https?:)$/.test(parsed.protocol) && !parsed.username && !parsed.password ? value : null;
    } catch (_) { return null; }
  }
  function imageData(image) {
    return image && (!image.media_type || image.media_type === 'image') && positive(image.id) && sourceURL(image.src) ? { id: id(image.id), src: image.src } : null;
  }
  function variantMedia(variant) {
    if (Object.prototype.hasOwnProperty.call(variant, 'featured_media')) {
      var media = variant.featured_media;
      // An explicit non-image type is authoritative, even if it has a preview.
      if (media && media.media_type != null && media.media_type !== 'image') return null;
      if (media && media.media_type === 'image' && positive(media.id) && media.preview_image && sourceURL(media.preview_image.src)) return { id: id(media.id), src: media.preview_image.src };
    }
    // Missing, untyped or incomplete media can use only this variant's assigned image.
    // Shopify's native variant JSON may expose its assigned image as featured_image instead.
    // This is variant-level only; product.featured_image is never read.
    var image = Object.prototype.hasOwnProperty.call(variant, 'featured_image') ? variant.featured_image : variant.image;
    return imageData(image);
  }
  function normalize(product) {
    if (!product || !positive(product.id) || CATEGORIES.indexOf(product.category) < 0 || !Array.isArray(product.optionNames) || product.optionNames.length < 1 || product.optionNames.length > 3 || product.optionNames.some(function (value) { return typeof value !== 'string' || !value.trim(); })) return null;
    if (new Set(product.optionNames.map(name)).size !== product.optionNames.length || !Number.isInteger(product.variantCount) || product.variantCount < 1 || product.variantCount > 250 || !Array.isArray(product.variants) || product.variants.length !== product.variantCount) return null;
    var position = Number(product.modelPosition);
    if (!Number.isInteger(position) || position < 0 || position > product.optionNames.length) return null;
    var seen = new Set(), variants = [];
    for (var raw of product.variants) {
      if (!raw || !positive(raw.id) || seen.has(id(raw.id)) || !Array.isArray(raw.options) || raw.options.length !== product.optionNames.length || raw.options.some(function (value) { return typeof value !== 'string'; }) || typeof raw.available !== 'boolean' || (raw.product_id != null && id(raw.product_id) !== id(product.id))) return null;
      seen.add(id(raw.id));
      variants.push({ id: id(raw.id), options: raw.options.slice(), available: raw.available, image: variantMedia(raw) });
    }
    return { id: id(product.id), title: typeof product.title === 'string' ? product.title : '', url: product.url, category: product.category, modelPosition: position, optionNames: product.optionNames.slice(), variantCount: product.variantCount, variants: variants, selectedVariantId: id(product.selectedVariantId), nativeVariantId: id(product.nativeVariantId), image: imageData(product.image) };
  }
  function config(raw) {
    var source = raw && normalize(raw.source);
    if (!source || typeof raw.sectionId !== 'string' || !raw.sectionId || !Array.isArray(raw.targets)) return null;
    var seen = new Set([source.id]);
    var targets = raw.targets.map(normalize).filter(function (target) {
      if (!target || target.category !== source.category || seen.has(target.id)) return false;
      seen.add(target.id); return true;
    });
    return { source: source, targets: targets, sectionId: raw.sectionId, maxVisible: Number.isInteger(raw.maxVisible) ? Math.max(1, Math.min(5, raw.maxVisible)) : 5 };
  }
  function selected(product, raw) {
    var p = normalize(product);
    if (!p || !raw || !positive(raw.id) || !Array.isArray(raw.options) || typeof raw.available !== 'boolean' || (raw.product_id != null && id(raw.product_id) !== p.id)) return null;
    return p.variants.find(function (variant) { return variant.id === id(raw.id) && raw.options.length === variant.options.length && variant.options.every(function (value, i) { return value === raw.options[i]; }) && variant.available === raw.available; }) || null;
  }
  function initial(product) {
    var p = normalize(product);
    if (!p || p.category === 'phone') return null;
    var chosen = p.selectedVariantId || p.nativeVariantId;
    if (chosen) return p.variants.find(function (variant) { return positive(chosen) && variant.id === chosen; }) || null;
    return p.variants.length === 1 ? p.variants[0] : null;
  }
  function validModel(model) { return typeof model === 'string' && Boolean(model.trim()); }
  function devicePosition(product) {
    if (product.modelPosition) return product.modelPosition - 1;
    if (['phone', 'airpods', 'airpods-max', 'kindle'].indexOf(product.category) < 0) return -1;
    var positions = product.optionNames.map(function (option, index) { return /^(model|phone model|device|device model|generation|size)$/i.test(option.trim()) ? index : -1; }).filter(function (index) { return index >= 0; });
    return positions.length === 1 ? positions[0] : -1;
  }
  function sourceVariant(product, state) {
    var p = normalize(product);
    if (!p || !state || !state.ready || state.state === 'pending' || id(state.productId) !== p.id) return null;
    var variant = p.variants.find(function (v) { return v.id === id(state.variantId); });
    if (!variant) return null;
    if (p.category === 'phone' && (!p.modelPosition || !validModel(state.model) || variant.options[p.modelPosition - 1] !== state.model)) return null;
    return variant;
  }
  function finishAlias(product, position) {
    return /^(surface|finish|color)$/i.test(product.optionNames[position].trim()) && product.variants.every(function (variant) { return /^(Glossy|Matte)$/.test(variant.options[position]); });
  }
  function compatible(source, target, original) {
    var sourceDevice = devicePosition(source), targetDevice = devicePosition(target);
    if (sourceDevice >= 0 || targetDevice >= 0) {
      if (sourceDevice < 0 || targetDevice < 0 || !validModel(original.options[sourceDevice])) return { device: false, variants: [] };
    } else if (source.category === 'airpods' || source.category === 'kindle') return { device: false, variants: [] };
    var deviceMatches = target.variants.filter(function (variant) { return targetDevice < 0 || variant.options[targetDevice] === original.options[sourceDevice]; });
    if (!deviceMatches.length) return { device: false, variants: [] };
    var matches = deviceMatches.filter(function (variant) {
      return target.optionNames.every(function (option, position) {
        if (position === targetDevice) return true;
        var sourcePositions = source.optionNames.map(function (candidate, index) { return index !== sourceDevice && name(candidate) === name(option) ? index : -1; }).filter(function (index) { return index >= 0; });
        if (!sourcePositions.length && finishAlias(target, position)) sourcePositions = source.optionNames.map(function (_, index) { return index !== sourceDevice && finishAlias(source, index) ? index : -1; }).filter(function (index) { return index >= 0; });
        if (sourcePositions.length > 1) return false;
        return !sourcePositions.length || variant.options[position] === original.options[sourcePositions[0]];
      });
    });
    return { device: true, variants: matches, targetSingleDevice: targetDevice < 0 || target.variants.every(function (variant) { return variant.options[targetDevice] === original.options[sourceDevice]; }) };
  }
  function resolve(source, target, state) {
    var s = normalize(source), t = normalize(target);
    if (!s || !t || s.id === t.id || s.category !== t.category || !t.variants.some(function (variant) { return variant.available; }) || (s.category === 'phone' && !t.modelPosition)) return { kind: 'omit' };
    if (state && (id(state.productId) !== s.id || state.state === 'pending')) return { kind: 'omit' };
    var original = sourceVariant(s, state);
    if (!original) {
      if (s.category === 'phone') return { kind: 'choose' };
      if (devicePosition(s) >= 0 || devicePosition(t) >= 0 || s.category === 'airpods' || s.category === 'kindle') return { kind: 'omit' };
      return { kind: 'choose' };
    }
    var candidates = compatible(s, t, original);
    // Uniqueness is decided before availability; an unavailable packaging/finish must not break a tie.
    if (!candidates.variants.length || !candidates.variants.some(function (variant) { return variant.available; })) return { kind: 'omit' };
    if (candidates.variants.length === 1) return { kind: 'exact', variant: candidates.variants[0] };
    if (s.category === 'phone') return { kind: candidates.device ? 'choose' : 'omit' };
    if (!candidates.device || !candidates.targetSingleDevice) return { kind: 'omit' };
    return { kind: 'choose' };
  }
  function match(source, target, state) { var result = resolve(source, target, state); return result.kind === 'exact' ? result.variant : null; }
  function media(product, variant) {
    var p = normalize(product);
    if (!p || !variant) return null;
    var chosen = p.variants.find(function (candidate) { return candidate.id === id(variant.id); });
    if (!chosen || !chosen.image) return null;
    // Use the image assigned to the exact matched variant, even when Shopify shares it.
    return chosen.image;
  }
  function browsingMedia(source, target, state, currentHref) {
    var s = normalize(source), t = normalize(target);
    if (!s || !t || s.category !== t.category || s.selectedVariantId || (state && (state.ready || state.model || state.state !== 'unset' || id(state.productId) !== s.id))) return null;
    // No controller is not proof of unset intent. A fixed-model product has no model controller.
    if (s.category === 'phone' ? (!state && s.modelPosition > 0) : (!state || s.nativeVariantId)) return null;
    try {
      var current = new URL(currentHref);
      if (current.searchParams.has('variant') || current.searchParams.has('option_values')) return null;
    } catch (_) { return null; }
    return t.image;
  }
  function previewMedia(source, target, state) {
    var s = normalize(source), t = normalize(target);
    if (!s || !t || s.category !== 'phone' || t.category !== 'phone' || !t.modelPosition || resolve(s, t, state).kind !== 'choose') return null;
    var original = sourceVariant(s, state);
    if (!original) return null;
    var candidates = compatible(s, t, original).variants;
    if (!candidates.length || !candidates.some(function (variant) { return variant.available; })) return null;
    var onlyFinishVaries = t.optionNames.every(function (_, position) {
      return position === t.modelPosition - 1 || new Set(candidates.map(function (variant) { return variant.options[position]; })).size === 1 || finishAlias(t, position);
    });
    if (!onlyFinishVaries) return null;
    var preview = candidates.find(function (variant) { return variant.available && variant.image; });
    return preview ? preview.image : null;
  }
  function thumbnail(src, currentHref) {
    try {
      var current = currentHref ? new URL(currentHref) : null;
      var image = new URL(src, current ? current.href : 'https://sibling.invalid');
      var cdn = image.hostname === 'cdn.shopify.com' && /^\/s\/files\//.test(image.pathname);
      var storefront = current && image.origin === current.origin && /^\/cdn\/shop\//.test(image.pathname);
      var signed = Array.from(image.searchParams.keys()).some(function (key) { return /^(x-amz-|x-goog-|signature$|sig$|token$|policy$|key-pair-id$|expires$|hmac$|auth)/i.test(key); });
      if ((cdn || storefront) && !signed && /^(https?:)$/.test(image.protocol) && !image.username && !image.password && /\.(avif|gif|jpe?g|png|webp)$/i.test(image.pathname)) {
        image.searchParams.set('width', '240');
        return image.href;
      }
    } catch (_) { /* Unknown image hosts and formats are not transformed. */ }
    return src;
  }
  function url(path, variantId, currentHref, chooseModel) {
    try {
      if (typeof path !== 'string' || /[\u0000-\u0020\\]/.test(path)) return null;
      var current = new URL(currentHref), target = new URL(path, current);
      if (!/^(https?:)$/.test(target.protocol) || target.origin !== current.origin || target.username || target.password || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[^/]+\/)?products\/[^/]+\/?$/i.test(target.pathname)) return null;
      target.search = ''; target.hash = '';
      if (variantId != null && variantId !== '') {
        if (!positive(variantId)) return null;
        target.searchParams.set('variant', id(variantId));
      } else if (chooseModel !== false) target.searchParams.set('shamos_model_choice', 'required');
      if (current.searchParams.get('view') === 'related-styles-pilot') target.searchParams.set('view', 'related-styles-pilot');
      var preview = current.searchParams.get('preview_theme_id');
      if (preview && positive(preview) && current.searchParams.getAll('preview_theme_id').length === 1) target.searchParams.set('preview_theme_id', preview);
      return target.pathname + target.search;
    } catch (_) { return null; }
  }
  return { normalize: normalize, config: config, initial: initial, selected: selected, sourceVariant: sourceVariant, resolve: resolve, match: match, media: media, browsingMedia: browsingMedia, previewMedia: previewMedia, thumbnail: thumbnail, url: url };
});

